import { render, staticRenderFns } from "./CardListProductPages.vue?vue&type=template&id=16e4460e&scoped=true"
import script from "./CardListProductPages.vue?vue&type=script&lang=js"
export * from "./CardListProductPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e4460e",
  null
  
)

export default component.exports